import { Injectable } from '@angular/core';

import { EntityStateProvider } from '../../core/domain/events/state_provider';
import { DietitianState } from '../../data/dietitian/domain/dietitian_state_provider';

@Injectable()
export class MyDietitianStateProvider extends EntityStateProvider<DietitianState> {}
